module.exports = __webpack_public_path__ + "img/swipe (4).efd2bf51.jpg";